angular.module('app.core').factory('grupoUsuarioFactory', ['$http', function ($http) {

    var _apiName = 'SysGrupoUsuario';

    var _list = function (search, options) {
        var dto = options.data;
        dto.search = search;
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            options.error(response.data);
        });
    };

    var _listAll = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAll', {});
    };

    var _addNew = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AddNew');
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _save = function (isNew, dto) {
        var method = isNew ? 'Insert' : 'Update';
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/' + method, dto);
    };

    var _delete = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Remove', dto);
    };

    var _listGrupoUsuarioPerfil = function (GrupoID) {
        var dto = {};
        dto.id = GrupoID;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListGrupoUsuarioPerfil', dto);
    };

    var _saveGrupoUsuarioPerfil = function (GrupoID, perfis) {
        var dto = {};
        dto.GrupoID = GrupoID;
        dto.Perfis = perfis;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/SaveGrupoUsuarioPerfil', dto);
    };

    var factory = {};

    factory.addNew = _addNew;
    factory.findRecord = _findRecord;
    factory.list = _list;
    factory.listAll = _listAll;
    factory.save = _save;
    factory.delete = _delete;
    factory.listGrupoUsuarioPerfil = _listGrupoUsuarioPerfil;
    factory.saveGrupoUsuarioPerfil = _saveGrupoUsuarioPerfil;

    return factory;

}]);
